<section
  fxLayout="row"
  fxLayoutGap="5px"
  fxLayoutAlign="start center"
  [ngClass]="{ 'mobile-section': isMobile$ | async }"
>
  <div class="app-icon"></div>
  <p
    class="app-store-description"
    [ngClass]="{ 'mobile-paragraph': isMobile$ | async }"
  >
    Manage your account anywhere with our
    {{ coreService.brandName | async }} app.
  </p>
  <a
    target="_blank"
    [href]="appStoreLink"
    aria-label="Download on the Apple App Store"
    class="app-store-icon"
    [ngClass]="{
      'mobile-app-store': isMobile$ | async,
      'mobile-store': isMobile$ | async
    }"
  >
    <img alt="Download on the App Store" class="img-alt"/>
  </a>
  <a
    target="_blank"
    [href]="googlePlayLink"
    aria-label="Download on the Google Play Store"
    class="google-play-icon"
    [ngClass]="{ 'mobile-store': isMobile$ | async }"
  >
    <img alt="Get it on Google Play" class="img-alt"/>
  </a>
</section>
